export default __webpack_public_path__ + "ca4a74fbc81857fe92b6a41b14811bf5.svg";